export default "__VITE_ASSET__CHrEHhmC__"